import { render } from "./LayoutBasic.vue?vue&type=template&id=68a6fd6e"
import script from "./LayoutBasic.vue?vue&type=script&lang=js"
export * from "./LayoutBasic.vue?vue&type=script&lang=js"

import "./LayoutBasic.vue?vue&type=style&index=0&id=68a6fd6e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__